import { Injectable } from '@angular/core';

import { IBetslipState } from '../../../../../base/store/state';
import { IFullBetslip } from '../../../../bet-generation/models';
import { BetslipError } from '../../../errors/betslip-error';
import { BetslipTypeErrors } from '../../../state';
import { BetslipTypeValidationComposerService } from './betslip-type-validation-composer.service';

@Injectable()
export class BetslipTypeValidationService {
    constructor(private composer: BetslipTypeValidationComposerService) {}

    validate(fullBetslip: IFullBetslip, state: IBetslipState): BetslipTypeErrors {
        return Object.values(fullBetslip.typeBetslips).reduce(
            (acc, typeBetslip) => {
                acc[typeBetslip.type] = this.composer.validate(typeBetslip, state);

                return acc;
            },
            {
                SINGLE: <BetslipError[]>[],
                COMBO: <BetslipError[]>[],
                SYSTEM: <BetslipError[]>[],
                TEASER: <BetslipError[]>[],
                EDIT_MY_BET: <BetslipError[]>[],
                BET_BUILDER: <BetslipError[]>[],
            },
        );
    }
}
